(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-cod-checkout"] && !Shopify.designMode) return;
  try {
    
  // Update delivery fee and total when a city is chosen; hide the summary once ordered.
  (() => {
    const totals = () => document.querySelector('.norel-checkout__totals');
    const format = (cents) => {
      const el = totals();
      const amount = (cents / 100).toFixed(2);
      const pattern = new RegExp('\\{' + '\\{\\s*\\w+\\s*\\}' + '\\}');
      return (el?.dataset.moneyFormat || amount + ' DH').replace(pattern, amount);
    };

    document.addEventListener('change', (event) => {
      const select = event.target.closest('.norel-checkout select[name="city"]');
      const el = totals();
      if (!select || !el) return;
      const option = select.selectedOptions[0];
      const fee = option && option.dataset.fee !== undefined ? Number(option.dataset.fee) : null;
      const feeEl = el.querySelector('[data-norel-fee]');
      const totalEl = el.querySelector('[data-norel-total]');
      const subtotal = Number(el.dataset.subtotalCents);
      if (fee === null) return;
      feeEl.textContent = fee > 0 ? format(fee * 100) : feeEl.dataset.free || format(0);
      totalEl.textContent = format(subtotal + fee * 100);
    });

    document.addEventListener('norel:order-placed', () => {
      const summary = document.querySelector('.norel-checkout__summary');
      if (summary) summary.hidden = true;
      document.querySelector('.norel-checkout__grid')?.style.setProperty('grid-template-columns', '1fr');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-hero-video"] && !Shopify.designMode) return;
  try {
    
  class NorelHeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.norel-hero__toggle');
      if (!this.video || !this.toggle) return;

      this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.userPaused) this.video.removeAttribute('autoplay');

      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.sync();
      });

      // Only play while on screen, to save battery and data on phones.
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    sync() {
      const paused = this.userPaused;
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      if (paused || !this.visible) {
        this.video.pause();
      } else {
        this.video.play().catch(() => {});
      }
    }
  }

  if (!customElements.get('norel-hero-video')) customElements.define('norel-hero-video', NorelHeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-mobile-hero"] && !Shopify.designMode) return;
  try {
    
  // "Discover" button: scroll smoothly to the product list (or the next section)
  // instead of leaving the page. Without JS it falls back to the all-products page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-norel-scroll]');
    if (!link) return;

    const hero = link.closest('.shopify-section');
    let target = null;
    if (link.dataset.norelScroll === 'products') {
      target = document.querySelector('.content-for-layout .section-resource-list')?.closest('.shopify-section');
    } else {
      for (let next = hero?.nextElementSibling; next; next = next.nextElementSibling) {
        if (next.offsetHeight > 0) {
          target = next;
          break;
        }
      }
    }
    if (!target) return;

    event.preventDefault();
    const headerHeight = document.querySelector('#header-component')?.offsetHeight || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-order-tracking"] && !Shopify.designMode) return;
  try {
    
  // Builds the WhatsApp message, with the order number when one is given.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-norel-wa-confirm]');
    if (!form) return;
    // No WhatsApp number set yet: the button does nothing.
    if (form.hasAttribute('data-wa-disabled')) return event.preventDefault();
    const input = form.querySelector('.norel-tracking__input');
    const digits = input.value.trim().replace(/^#/, '');
    form.querySelector('input[name="text"]').value = digits
      ? form.dataset.template.replace('__ORDER__', '#' + digits)
      : form.dataset.plain;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class NorelCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.norel-carousel__track');
      this.prev = this.querySelector('[data-action="prev"]');
      this.next = this.querySelector('[data-action="next"]');
      this.toggle = this.querySelector('[data-action="toggle"]');
      if (!this.track) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rtl = getComputedStyle(this).direction === 'rtl';

      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateArrows();
        });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.updateArrows();

      if (this.hasAttribute('data-autoplay') && !this.reducedMotion) this.setupAutoplay();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }

    /** Width of one card plus the gap, i.e. one step of the carousel. */
    get stepSize() {
      const slide = this.track.querySelector('.norel-carousel__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    /** Scroll position measured from the start edge, positive in both LTR and RTL. */
    get position() {
      return Math.abs(this.track.scrollLeft);
    }

    get maxPosition() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    step(direction) {
      const sign = this.rtl ? -1 : 1;
      this.track.scrollBy({
        left: direction * sign * this.stepSize,
        behavior: this.reducedMotion ? 'auto' : 'smooth',
      });
    }

    updateArrows() {
      const atStart = this.position <= 2;
      const atEnd = this.position >= this.maxPosition - 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }

    setupAutoplay() {
      this.delay = Number(this.dataset.speed) || 5000;
      this.paused = false;
      this.holds = new Set();

      if (this.toggle) {
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.setAttribute(
            'aria-label',
            this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause
          );
          this.sync();
        });
      }

      // Hover, keyboard focus and touch all hold the carousel still.
      const hold = (reason) => () => { this.holds.add(reason); this.sync(); };
      const release = (reason) => () => { this.holds.delete(reason); this.sync(); };
      this.addEventListener('pointerenter', hold('hover'));
      this.addEventListener('pointerleave', release('hover'));
      this.addEventListener('focusin', hold('focus'));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) release('focus')();
      });
      this.track.addEventListener('touchstart', hold('touch'), { passive: true });
      this.track.addEventListener('touchend', () => {
        clearTimeout(this.touchTimer);
        this.touchTimer = setTimeout(release('touch'), this.delay);
      }, { passive: true });

      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      });
      this.visibilityObserver.observe(this);
      document.addEventListener('visibilitychange', () => this.sync());
    }

    sync() {
      const running = !this.paused && this.holds.size === 0 && this.visible && !document.hidden;
      if (running && !this.timer) {
        this.timer = setInterval(() => this.advance(), this.delay);
      } else if (!running) {
        this.stopTimer();
      }
    }

    advance() {
      if (this.position >= this.maxPosition - 2) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.step(1);
      }
    }

    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('norel-carousel')) customElements.define('norel-carousel', NorelCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norel-promo-popup"] && !Shopify.designMode) return;
  try {
    
  class NorelPromoPopup extends HTMLElement {
    connectedCallback() {
      if (this.dialog) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.dialog.addEventListener('click', (event) => {
        // A click on the dark backdrop lands on the <dialog> itself.
        if (event.target === this.dialog || event.target.closest('[data-close]')) this.close();
      });
      this.dialog.addEventListener('cancel', () => this.remember());
      this.querySelectorAll('[data-close-on-click]').forEach((link) => link.addEventListener('click', () => this.remember()));

      // In the theme editor, show it straight away so it can be edited.
      if (this.hasAttribute('data-design-mode')) {
        this.open();
        return;
      }
      if (this.recentlySeen()) return;
      const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
      this.timer = setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    open() {
      // Don't cover another open dialog (cart, menu, zoom).
      if (document.querySelector('dialog[open]:not(.norel-popup)')) {
        this.timer = setTimeout(() => this.open(), 4000);
        return;
      }
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      this.remember();
      this.dialog.close();
    }

    recentlySeen() {
      try {
        const seen = Number(localStorage.getItem(this.dataset.key) || 0);
        const days = Number(this.dataset.days) || 0;
        return seen > 0 && Date.now() - seen < days * 86400000;
      } catch {
        return false;
      }
    }

    remember() {
      if (this.hasAttribute('data-design-mode')) return;
      try {
        localStorage.setItem(this.dataset.key, String(Date.now()));
      } catch {}
    }
  }

  if (!customElements.get('norel-promo-popup')) customElements.define('norel-promo-popup', NorelPromoPopup);

  } catch(e) { console.error(e); }
})();
})();
